import {computed, ref} from 'vue'
import {useToast} from '@nuxt/ui/composables/useToast'
import {isLocal} from '@/services/infrastructure/envhelper.service'

export const gitVersion = computed(() => {
    /* @ts-ignore */
    return document.head.querySelector('[name="application-name"]')?.content.split(': ')[1]
})

const lastVersionNotified = ref('')
const updateToastIsActive = ref(false)

export const versionCheckerVuePlugin = {
    install: () => {
        if(isLocal()) return
        const toast = useToast()

        setInterval(async () => {
            const viteVersion = gitVersion.value
            const fetchedVersion = (await fetch('/version.txt', {cache: 'no-store'}).then(res => res.text()).catch(() => null)) || ''
            console.debug({viteVersion, fetchedVersion, lastVersionNotified: lastVersionNotified.value})
            if (fetchedVersion !== viteVersion && lastVersionNotified.value !== fetchedVersion && !updateToastIsActive.value) {
                updateToastIsActive.value = true
                toast.add({
                    title: 'Ny versjon',
                    description: 'En ny versjon av Conta Pro er tilgjengelig',
                    icon: 'i-ph-arrow-clockwise',
                    color: 'info',
                    duration: 0,
                    close: {
                        onClick: () => {
                            updateToastIsActive.value = false
                        }
                    },
                    actions: [
                        {
                            icon: 'i-ph-arrow-clockwise',
                            label: 'Oppdater nå',
                            onClick: () => {
                                window.location.reload()
                            }
                        }
                    ]
                })
            }
            lastVersionNotified.value = fetchedVersion

        }, 60000)
    }
}